<template>
  <v-container tag="section" fluid>
    <validation-observer ref="observer" v-slot="{ invalid }" slim>
      <v-row align="center">
        <v-col cols="12">
          <base-material-card color="primary" icon="mdi-broom" inline class="ml-0 px-5 py-4">
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">Adicionar Caderno de Serviços</div>
            </template>

            <v-form class="mt-5">
              <v-row align="center" class="mx-auto">
                <v-col cols="12">
                  <validation-provider id="titulo-caderno-servicos" v-slot="{ errors }" rules="required|max:60">
                    <v-text-field v-model="nome" label="Título" outlined :error-messages="errors" />
                  </validation-provider>
                </v-col>
              </v-row>

              <v-row align="center" class="mx-auto">
                <v-col id="caderno-servicos-v-alert" cols="12" class="py-0">
                  <v-alert dense outlined type="info" color="blue" class="pa-2">
                    <a @click="$router.push('/parametros-com-ca/modelos-cadernos-servicos')">Clique aqui</a>
                    para criar e baixar um modelo do sistema. Edite, salve como .CSV e envie.
                  </v-alert>
                </v-col>
              </v-row>

              <div id="caderno-servicos-campos-arquivo">
                <v-row align="center" class="mx-auto">
                  <v-col cols="12" class="pl-2">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <v-file-input
                        v-model="arquivo.fileObj"
                        label="Arquivo CSV"
                        placeholder="Selecione um arquivo CSV"
                        outlined
                        accept=".csv, .zip"
                        truncate-length="30"
                        :loading="arquivo.uploading"
                        loader-height="4"
                        :success="arquivo.id && arquivo.fileObj ? true : false"
                        :error-messages="errors"
                        @change="uploadNewFile()"
                      />
                    </validation-provider>

                    <validation-provider rules="required">
                      <input type="hidden" name="validate-upload-caderno-servicos" :value="arquivo.id" />
                    </validation-provider>
                  </v-col>
                </v-row>

                <parametros-arquivo-csv
                  :delimitador.sync="arquivo.delimitador"
                  :involucro.sync="arquivo.involucro"
                  :escape.sync="arquivo.escape"
                />
              </div>
            </v-form>
          </base-material-card>
        </v-col>

        <v-col cols="12">
          <v-btn
            id="btn-save-caderno-servicos"
            color="success"
            min-width="100"
            style="float: right"
            :disabled="invalid"
            :loading="loading"
            @click="salvarCaderno()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
  import ArquivosService from '@/services/ArquivosService.js';
  import ConfiguracoesService from '@/services/ConfiguracoesService.js';
  import CadernosServicosService from '@/services/parametrosComCa/CadernosServicosService';

  export default {
    name: 'AddCadernoDeServicos',

    components: {
      ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv.vue')
    },

    data() {
      return {
        nome: '',
        arquivo: {
          fileObj: undefined,
          id: '',
          delimitador: `;`,
          involucro: `"`,
          escape: `"`,
          uploading: false
        },
        loading: false
      };
    },

    computed: {
      user() {
        return this.$store.getters.getUser;
      }
    },

    mounted() {
      this.getCsvCamposPadroes();
    },

    methods: {
      salvarCaderno() {
        const postData = {
          nome: this.nome,
          arquivo_id: this.arquivo.id,
          delimitador: this.arquivo.delimitador,
          involucro: this.arquivo.involucro,
          escape: this.arquivo.escape
        };

        this.loading = true;

        CadernosServicosService.salvarCaderno(postData)
          .then(() => {
            this.$toast.success('Caderno de Serviços salvo com sucesso.', '', { position: 'topRight' });
            this.$router.push({ name: 'Cadernos de Serviço' });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao salvar Caderno de Serviços.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },
      getCsvCamposPadroes() {
        ConfiguracoesService.getCsvCamposPadroes()
          .then((response) => {
            this.arquivo.delimitador = response.data.campos.delimitador.valor;
            this.arquivo.involucro = response.data.campos.involucro.valor;
            this.arquivo.escape = response.data.campos.escape.valor;
          })
          .catch((err) => {
            console.error('Erro ao recuperar campos padrões do arquivo csv: ', err);
            this.$toast.error('Erro ao recuperar campos padrões do arquivo csv.', '', { position: 'topRight' });
          });
      },
      uploadNewFile() {
        if (!this.arquivo.fileObj) return;

        this.arquivo.id = '';
        this.arquivo.uploading = true;

        let data = new FormData();
        data.append('file', this.arquivo.fileObj);

        ArquivosService.uploadFile(data)
          .then(async (response) => {
            await this.validaHeader(
              response.data.arquivoId,
              this.arquivo.delimitador,
              this.arquivo.involucro,
              this.arquivo.escape
            );

            this.arquivo.id = response.data.arquivoId;
          })
          .catch((err) => {
            console.error(err);

            if (err?.data?.error_code == 1001) {
              this.$toast.error(err.data.erro, '', { position: 'topRight', timeout: 6000 });
            } else if (err?.data?.cod_erro == 10000) {
              let msg = 'Há mais de um arquido dentro do ZIP.<br>Adicione apenas um arquivo CSV.';
              this.$toast.error(msg, '', { position: 'topRight', timeout: 8000 });
            } else {
              this.$toast.error('Erro no upload do arquivo.', '', { position: 'topRight' });
            }

            this.arquivo.fileObj = undefined;
          })
          .finally(() => (this.arquivo.uploading = false));
      },
      validaHeader(arquivoId, delimitador, involucro, escape) {
        return CadernosServicosService.validarHeader({ arquivoId, delimitador, involucro, escape }).catch((err) => {
          throw err;
        });
      }
    }
  };
</script>